
export class EmailCancelOrder {
    customerName: string;
    orderDetails: any;
    emailId: string;
    orderId: string;
}
